import React, { useEffect, useState } from 'react';
import { Card, Form, Select, Radio, Input, Button, message, Typography } from 'antd';
import { useNotificationActions } from '_actions';
import { ROLE_GROUPS } from '_helpers/roles';

const { Title } = Typography;

export { SendNotifications };

function SendNotifications() {
    const actions = useNotificationActions();
    const userData = JSON.parse(localStorage.getItem('userData')) || {};
    const isManager = ROLE_GROUPS.MANAGERS.includes(userData.role);

    const [classes, setClasses] = useState([]);
    const [classId, setClassId] = useState(null);
    const [members, setMembers] = useState([]);
    const [target, setTarget] = useState('class');   // 'class' | 'students' | 'all' | 'teachers'
    const [studentIds, setStudentIds] = useState([]);
    const [teachers, setTeachers] = useState([]);
    const [teacherIds, setTeacherIds] = useState([]);  // empty = all teachers
    const [kind, setKind] = useState('manual');        // 'manual' | 'tuition'
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [sending, setSending] = useState(false);

    useEffect(() => {
        actions.getMyClasses().then(setClasses);
        if (isManager) actions.getTeachers().then(setTeachers);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (target !== 'all' && classId) actions.getClassMembers(classId).then(setMembers);
        else setMembers([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classId, target]);

    async function onSend() {
        if ((target === 'class' || target === 'students') && !classId) return message.warning('Hãy chọn lớp');
        if (target === 'students' && studentIds.length === 0) return message.warning('Hãy chọn học sinh');
        if ((target === 'teachers' || kind === 'manual') && (!title.trim() || !body.trim())) return message.warning('Nhập tiêu đề và nội dung');

        const effectiveKind = target === 'teachers' ? 'manual' : kind;
        const payload = { target, kind: effectiveKind };
        if (target === 'class' || target === 'students') payload.class_id = classId;
        if (target === 'students') payload.student_ids = studentIds;
        if (target === 'teachers' && teacherIds.length) payload.teacher_ids = teacherIds;
        if (effectiveKind === 'manual') { payload.title = title; payload.body = body; }

        setSending(true);
        try {
            const res = await actions.sendNotification(payload);
            if (res.status === 'Success') {
                message.success(`Đã gửi tới ${res.message?.sent ?? 0} người`);
                setTitle(''); setBody(''); setStudentIds([]); setTeacherIds([]);
            } else {
                message.error(res.message || 'Gửi thất bại');
            }
        } catch (e) {
            message.error('Gửi thất bại');
        } finally {
            setSending(false);
        }
    }

    return (
        <Card style={{ maxWidth: 640, margin: '0 auto' }}>
            <Title level={4}>Gửi thông báo</Title>
            <Form layout="vertical">
                <Form.Item label="Gửi đến">
                    <Radio.Group value={target} onChange={e => setTarget(e.target.value)}>
                        <Radio value="class">Cả lớp</Radio>
                        <Radio value="students">Học sinh cụ thể</Radio>
                        {isManager && <Radio value="all">Toàn bộ học sinh</Radio>}
                        {isManager && <Radio value="teachers">Giáo viên</Radio>}
                    </Radio.Group>
                </Form.Item>

                {(target === 'class' || target === 'students') && (
                    <Form.Item label="Lớp">
                        <Select
                            placeholder="Chọn lớp"
                            value={classId}
                            onChange={setClassId}
                            options={classes.map(c => ({ value: c.class_id, label: c.class_name || c.class_id }))}
                        />
                    </Form.Item>
                )}

                {target === 'students' && (
                    <Form.Item label="Học sinh">
                        <Select
                            mode="multiple"
                            placeholder="Chọn học sinh"
                            value={studentIds}
                            onChange={setStudentIds}
                            optionFilterProp="label"
                            options={members.map(m => ({ value: m._id, label: `${m.name || ''} (${m.student_id || ''})` }))}
                        />
                    </Form.Item>
                )}

                {target === 'teachers' && (
                    <Form.Item label="Giáo viên (để trống = tất cả)">
                        <Select
                            mode="multiple"
                            placeholder="Tất cả giáo viên"
                            value={teacherIds}
                            onChange={setTeacherIds}
                            optionFilterProp="label"
                            options={teachers.map(t => ({ value: t._id, label: `${t.name || ''} (${t.student_id || ''})` }))}
                        />
                    </Form.Item>
                )}

                {target !== 'teachers' && (
                    <Form.Item label="Loại">
                        <Radio.Group value={kind} onChange={e => setKind(e.target.value)}>
                            <Radio value="manual">Tin nhắn</Radio>
                            <Radio value="tuition">Nhắc học phí (số buổi còn lại)</Radio>
                        </Radio.Group>
                    </Form.Item>
                )}

                {(target === 'teachers' || kind === 'manual') && (
                    <>
                        <Form.Item label="Tiêu đề">
                            <Input value={title} onChange={e => setTitle(e.target.value)} maxLength={120} />
                        </Form.Item>
                        <Form.Item label="Nội dung">
                            <Input.TextArea value={body} onChange={e => setBody(e.target.value)} rows={4} maxLength={1000} />
                        </Form.Item>
                    </>
                )}

                <Button type="primary" loading={sending} onClick={onSend}>Gửi</Button>
            </Form>
        </Card>
    );
}
